import { render, staticRenderFns } from "./FoodAllergiesTemplate.vue?vue&type=template&id=4aee56ef"
import script from "./FoodAllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./FoodAllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports